import React from 'react';
import { motion } from 'framer-motion';

const TermsOfService: React.FC = () => {
  return (
    <motion.div
      className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12 transition-colors duration-200"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-8 transition-colors duration-200">
          {/* 页面标题 */}
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">使用条款</h1>
            <p className="text-gray-600 dark:text-gray-300">AI咖 Terms of Service</p>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">最后更新时间：2025年6月</p>
          </div>

          {/* 条款内容 */}
          <div className="prose prose-gray max-w-none">
            
            {/* 前言 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">前言</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                欢迎使用AI咖（以下简称"本服务"）！本使用条款（以下简称"本条款"）是您与我们之间关于您使用本服务所订立的协议。请您在使用本服务前仔细阅读本条款的全部内容，特别是免除或者限制责任的条款。
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                <strong>您点击"同意"、"注册"按钮或实际使用本服务，即视为您已阅读并同意签署本条款。</strong>如您不同意本条款的任意内容，或者无法准确理解相关条款的含义，请不要进行后续操作。
              </p>
            </section>

            {/* 服务内容 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">1. 服务内容</h2>
              
              <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-3">1.1 服务介绍</h3>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                AI咖是一个专业的AI提示词管理系统，包括但不限于以下功能：
              </p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                <li>AI提示词的创建、编辑、删除和管理</li>
                <li>提示词的分类、标签和搜索功能</li>
                <li>提示词的导入、导出和分享功能</li>
                <li>Chrome浏览器扩展应用</li>
                <li>用户账户管理和数据同步</li>
                <li>其他相关的辅助功能</li>
              </ul>

              <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-3">1.2 服务变更</h3>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                我们有权根据业务发展需要，对服务内容进行调整、升级或终止。我们会通过合理方式提前通知您重大变更，但不承担因服务变更给您造成的损失。
              </p>
            </section>

            {/* 用户账户 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">2. 用户账户</h2>
              
              <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-3">2.1 账户注册</h3>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                <li>您需要注册账户才能使用部分服务功能</li>
                <li>注册时请提供真实、准确的信息</li>
                <li>您应当及时更新账户信息以保持其准确性</li>
                <li>您不得注册多个账户进行恶意操作</li>
                <li>您不得将账户出租、出售或转让给他人使用</li>
              </ul>

              <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-3">2.2 账户安全</h3>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                <li>您有责任维护账户密码的安全性</li>
                <li>如发现账户被盗用，请立即联系我们</li>
                <li>您对账户下的所有活动承担责任</li>
                <li>我们建议您定期更换密码以保证账户安全</li>
              </ul>
            </section>

            {/* 使用规范 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">3. 使用规范</h2>
              
              <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-3">3.1 合法使用</h3>
              <p className="text-gray-700 dark:text-gray-300 mb-4">您在使用本服务时应当遵守以下规定：</p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                <li>遵守中华人民共和国相关法律法规</li>
                <li>不得利用本服务从事违法犯罪活动</li>
                <li>不得发布违法、违规或有害信息</li>
                <li>不得侵犯他人知识产权或其他合法权益</li>
                <li>不得传播虚假信息或进行欺诈活动</li>
                <li>不得进行恶意攻击或破坏系统安全</li>
              </ul>

              <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-3">3.2 禁止行为</h3>
              <p className="text-gray-700 dark:text-gray-300 mb-4">以下行为被严格禁止：</p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                <li>使用技术手段恶意攻击或干扰服务正常运行</li>
                <li>尝试破解、逆向工程或反编译软件</li>
                <li>批量注册账户或使用自动化工具</li>
                <li>传播病毒、恶意代码或其他有害程序</li>
                <li>盗取他人账户信息或个人数据</li>
                <li>进行任何形式的商业作弊或欺诈行为</li>
              </ul>

              <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-3">3.3 内容规范</h3>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2">
                <li>您创建的提示词内容应当合法合规</li>
                <li>不得包含色情、暴力、恐怖主义等有害内容</li>
                <li>不得侵犯他人版权、商标权等知识产权</li>
                <li>不得包含个人隐私信息或商业机密</li>
                <li>我们有权对违规内容进行删除或屏蔽</li>
              </ul>
            </section>

            {/* 知识产权 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">4. 知识产权</h2>
              
              <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-3">4.1 服务知识产权</h3>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                <li>本服务的软件、界面设计、程序代码等知识产权归我们所有</li>
                <li>未经授权，您不得复制、修改、分发或商业利用</li>
                <li>本服务基于开源协议，具体权利义务请参考相关开源许可证</li>
              </ul>

              <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-3">4.2 用户内容权利</h3>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                <li>您对自己创建的提示词内容拥有知识产权</li>
                <li>您授权我们存储、展示和传输您的内容以提供服务</li>
                <li>您保证拥有所上传内容的合法权利</li>
                <li>如发生知识产权纠纷，您承担相应法律责任</li>
              </ul>
            </section>

            {/* 免责声明 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">5. 免责声明</h2>
              
              <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-3">5.1 服务提供</h3>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                <li>本服务按"现状"提供，我们不保证服务绝对无误或无中断</li>
                <li>我们不对服务的适用性、准确性、完整性作出保证</li>
                <li>由于技术故障、维护升级等原因导致的服务中断，我们不承担责任</li>
                <li>第三方服务或链接的问题不在我们的责任范围内</li>
              </ul>

              <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-3">5.2 用户行为</h3>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                <li>您对使用本服务的行为及其后果承担全部责任</li>
                <li>因您违反本条款造成的损失，由您自行承担</li>
                <li>您与其他用户发生的纠纷，我们不承担调解或赔偿责任</li>
              </ul>
            </section>

            {/* 数据保护 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">6. 数据保护与备份</h2>
              
              <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-3">6.1 数据安全</h3>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                <li>我们采用合理的技术措施保护您的数据安全</li>
                <li>我们会定期备份重要数据，但不保证数据绝对不会丢失</li>
                <li>您应当自行备份重要的提示词内容</li>
                <li>我们有权删除长期未使用的账户数据</li>
              </ul>

              <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-3">6.2 数据迁移</h3>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2">
                <li>您有权导出自己的数据</li>
                <li>如服务终止，我们会提前通知并提供数据导出功能</li>
                <li>数据格式可能会根据技术需要进行调整</li>
              </ul>
            </section>

            {/* 违约处理 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">7. 违约处理</h2>
              
              <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-3">7.1 违约行为</h3>
              <p className="text-gray-700 dark:text-gray-300 mb-4">如您违反本条款，我们有权采取以下措施：</p>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                <li>警告或要求改正</li>
                <li>删除违规内容</li>
                <li>限制账户功能</li>
                <li>暂停或终止服务</li>
                <li>追究法律责任</li>
              </ul>

              <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-3">7.2 损害赔偿</h3>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                如您的违约行为给我们或他人造成损失，您应当承担相应的赔偿责任。
              </p>
            </section>

            {/* 服务终止 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">8. 服务终止</h2>
              
              <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-3">8.1 终止情形</h3>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                <li>您主动注销账户或停止使用服务</li>
                <li>您严重违反本条款且拒不改正</li>
                <li>法律法规要求或政府部门要求</li>
                <li>我们因商业原因停止服务</li>
              </ul>

              <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-3">8.2 终止后果</h3>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2">
                <li>您将无法继续使用服务</li>
                <li>我们会保留必要数据一段时间后删除</li>
                <li>双方在本条款下的权利义务关系终止</li>
                <li>已产生的法律责任不因终止而免除</li>
              </ul>
            </section>

            {/* 法律适用 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">9. 法律适用与争议解决</h2>
              
              <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-3">9.1 法律适用</h3>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                本条款的订立、效力、解释、履行和争议解决适用中华人民共和国法律。
              </p>

              <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-3">9.2 争议解决</h3>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2">
                <li>双方应首先通过友好协商解决争议</li>
                <li>协商不成的，任何一方可向有管辖权的人民法院提起诉讼</li>
                <li>在争议解决期间，双方应继续履行本条款中的其他条款</li>
              </ul>
            </section>

            {/* 其他条款 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">10. 其他条款</h2>
              
              <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-3">10.1 条款修改</h3>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                我们有权根据法律法规变化或业务发展需要修改本条款。修改后的条款将通过适当方式通知您，继续使用服务即视为接受修改后的条款。
              </p>

              <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-3">10.2 条款效力</h3>
              <ul className="list-disc pl-6 text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                <li>本条款的任何条款被认定无效，不影响其他条款的效力</li>
                <li>我们未行使任何权利不构成对该权利的放弃</li>
                <li>本条款构成双方就相关事项的完整协议</li>
              </ul>
            </section>

            {/* 联系方式 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">11. 联系我们</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                如果您对本使用条款有任何疑问，请通过以下方式联系我们：
              </p>
              <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                <ul className="text-gray-700 dark:text-gray-300 space-y-2">
                  <li><strong>小红书：</strong> 朝朝AI工坊</li>
                  <li><strong>抖音：</strong> 朝朝AI工坊</li>
                  <li><strong>微信：</strong> 扫描页面底部二维码添加</li>
                  <li><strong>响应时间：</strong> 我们将在24小时内回复您的请求</li>
                </ul>
              </div>
            </section>

            {/* 生效日期 */}
            <section className="border-t border-gray-200 dark:border-gray-700 pt-6">
              <p className="text-sm text-gray-500 text-center">
                本使用条款于2025年6月生效。本条款的解释权归AI咖所有。
              </p>
            </section>

          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default TermsOfService; 